module.exports = __webpack_public_path__ + "static/img/bcg_karty.2beff59d.png";